import { render, staticRenderFns } from "./Prompts.vue?vue&type=template&id=092d6425&scoped=true"
import script from "./Prompts.vue?vue&type=script&lang=js"
export * from "./Prompts.vue?vue&type=script&lang=js"
import style0 from "./Prompts.vue?vue&type=style&index=0&id=092d6425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092d6425",
  null
  
)

export default component.exports